<script lang="ts">
    import AppLayout from "@/layouts/AppLayout.svelte";
    import {Plus} from "lucide-svelte";
    import type {Customer, Site} from "@/types/types";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import SiteTable from "@/components/sites/SiteTable.svelte";
    import CreateRecordModal from "@/components/CreateRecordModal.svelte";
    import CreateSiteModal from "@/components/sites/CreateSiteModal.svelte";


    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
    };

    let {blocks}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Site', href: route('sites.index')},
    ]);


    let showCreateSiteModal = $state(false);
    function openCreateSiteModal() {
        showCreateSiteModal = true;
    }

    let actionbuttons = $state([
        {
            title: 'Add New Site',
            href: undefined,
            icon: Plus,
            onClick: openCreateSiteModal,
        },
    ]);

</script>

<svelte:head>
    <title>Sites</title>
</svelte:head>
<!--</HeaderActionButtons>-->
<AppLayout {breadcrumbs} {actionbuttons}>
    <div>
        <SiteTable view="index"/>
    </div>
    <CreateSiteModal
        blocks={blocks}
        show={showCreateSiteModal}
        />

</AppLayout>
